module.exports = __webpack_public_path__ + "img/logo-2.62ed0655.png";